import { createAction, props } from '@ngrx/store';

import { CardAdjustments, PaymentDetails } from '../components/methods/payment-methods.models';

import { Order } from '@api/order/order.models';
import { PaymentMethod, PaymentModeInfo, SelectedDiscount } from '@features/payment';
import { PurchaseAttempt } from '@features/purchase-attempt';

export const ActionTypes = {
    PAYMENT_INITIALIZED: '[Payment] PAYMENT_INITIALIZED',
    LOAD_PAYMENT_METHODS: '[Payment] LOAD_PAYMENT_METHODS',
    LOAD_PAYMENT_METHODS_SUCCESS: '[Payment] LOAD_PAYMENT_METHODS_SUCCESS',
    LOAD_PAYMENT_METHODS_ERROR: '[Payment] LOAD_PAYMENT_METHODS_ERROR',
    SET_SELECTED_PAYMENT_METHOD: '[Payment] SET_SELECTED_PAYMENT_METHOD',
    SET_SELECTED_PAYMENT_METHOD_SUCCESS: '[Payment] SET_SELECTED_PAYMENT_METHOD_SUCCESS',
    SET_SELECTED_PAYMENT_METHOD_ERROR: '[Payment] SET_SELECTED_PAYMENT_METHOD_ERROR',
    SET_PAYMENT_DETAILS: '[Payment] SET_PAYMENT_DETAILS',
    SET_PAYMENT_MODE: '[Payment] SET_PAYMENT_MODE',
    SET_DISCOUNT_DETAILS: '[Payment] SET_DISCOUNT_DETAILS',
    SET_DISCOUNT_DETAILS_SUCCESS: '[Payment] SET_DISCOUNT_DETAILS_SUCCESS',
    SET_DISCOUNT_DETAILS_ERROR: '[Payment] SET_DISCOUNT_DETAILS_ERROR',
    RELOAD_CAPTCHA: '[Payment] RELOAD_CAPTCHA',
    SET_PAYMENT_READY: '[Payment] SET_PAYMENT_READY',
    UNSET_PAYMENT_READY: '[Payment] UNSET_PAYMENT_READY',
    TOGGLE_DISCOUNT_METHOD: '[Payment] TOGGLE_DISCOUNT_METHOD',
    TOGGLE_DISCOUNT_METHOD_SUCCESS: '[Payment] TOGGLE_DISCOUNT_METHOD_SUCCESS',
    TOGGLE_DISCOUNT_METHOD_ERROR: '[Payment] TOGGLE_DISCOUNT_METHOD_ERROR',
    PAYMENT_DESTROYED: '[Payment] PAYMENT_DESTROYED',
    SET_REPAY: '[Payment] SET_REPAY',
    LOAD_PURCHASE_ATTEMPT_SUCCESS: '[Payment] LOAD_PURCHASE_ATTEMPT_SUCCESS',
    LOAD_FILTERED_PAYMENT_METHODS: '[Payment] LOAD_FILTERED_PAYMENT_METHODS',
};

// Acciones del payment
export const PaymentInitialized = createAction(
    ActionTypes.PAYMENT_INITIALIZED,
);

export const LoadPaymentMethods = createAction(
    ActionTypes.LOAD_PAYMENT_METHODS,
    (payload: { orderId?: string } = {}) => ({ ...payload }),
);
export const LoadPaymentMethodsSuccess = createAction(
    ActionTypes.LOAD_PAYMENT_METHODS_SUCCESS,
    props<{ values: PaymentMethod[] }>(),
);
export const LoadPaymentMethodsError = createAction(
    ActionTypes.LOAD_PAYMENT_METHODS_ERROR,
    props<{ error: any }>(),
);
export const SetSelectedPaymentMethod = createAction(
    ActionTypes.SET_SELECTED_PAYMENT_METHOD,
    props<{ selectedPaymentMethod: PaymentMethod }>(),
);
export const SetSelectedPaymentMethodSuccess = createAction(
    ActionTypes.SET_SELECTED_PAYMENT_METHOD_SUCCESS,
    props<{ values: Order }>(),
);
export const SetSelectedPaymentMethodError = createAction(
    ActionTypes.SET_SELECTED_PAYMENT_METHOD_ERROR,
    props<{ error: any }>(),
);
export const SetPaymentDetails = createAction(ActionTypes.SET_PAYMENT_DETAILS, props<{ paymentDetails: PaymentDetails }>());
export const SetPaymentMode = createAction(ActionTypes.SET_PAYMENT_MODE, props<{ paymentModeInfo: PaymentModeInfo }>());
export const SetDiscountDetails = createAction(
    ActionTypes.SET_DISCOUNT_DETAILS,
    props<{ cardAdjustments: CardAdjustments; discountMethod: PaymentMethod }>(),
);
export const SetDiscountDetailsSuccess = createAction(
    ActionTypes.SET_DISCOUNT_DETAILS_SUCCESS,
    props<{ selectedDiscount: SelectedDiscount[]; paymentReady: boolean }>(),
);
export const SetDiscountDetailsError = createAction(ActionTypes.SET_DISCOUNT_DETAILS_ERROR, props<{ error: any }>());
export const SetPaymentReady = createAction(ActionTypes.SET_PAYMENT_READY, props<{ paymentReady: boolean }>());
export const ToggleDiscountMethod = createAction(
    ActionTypes.TOGGLE_DISCOUNT_METHOD,
    props<{ discount: SelectedDiscount; enabled: boolean }>(),
);
export const ToggleDiscountMethodSuccess = createAction(
    ActionTypes.TOGGLE_DISCOUNT_METHOD_SUCCESS,
    props<{ selectedDiscount: SelectedDiscount[]; paymentReady: boolean }>(),
);
export const ToggleDiscountMethodError = createAction(ActionTypes.TOGGLE_DISCOUNT_METHOD_ERROR, props<{ error: any }>());

export const PaymentDestroyed = createAction(
    ActionTypes.PAYMENT_DESTROYED,
);

export const SetRepay = createAction(
    ActionTypes.SET_REPAY,
    props<{ isRepay: boolean }>(),
);

export const LoadPurchaseAttemptSuccess = createAction(
    ActionTypes.LOAD_PURCHASE_ATTEMPT_SUCCESS,
    props<{ values: PurchaseAttempt }>(),
);

export const LoadFilteredPaymentMethods = createAction(
    ActionTypes.LOAD_FILTERED_PAYMENT_METHODS,
    props<{ paymentMethods: PaymentMethod[] }>(),
);

export const ReloadCaptcha = createAction(ActionTypes.RELOAD_CAPTCHA);
